// FAQ
// Check if there is any Faq
const faqGroups = document.getElementsByClassName('o-simple-faq__inner');
if (faqGroups.length > 0) {
  for (let i = 0; i < faqGroups.length; i++) {
    activeGroupListener(faqGroups[i]);
  }
}

function activeGroupListener(questionGroup) {
  const questionTitles = questionGroup.getElementsByClassName('o-simple-faq__question');
  for (let i = 0; i < questionTitles.length; i++) {
    questionTitles[i].addEventListener('click', function () {
      this.classList.toggle("show");
    });
  }
}